import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrimengModule } from '../shared/primeng/primeng.module';

@NgModule({
    declarations: [],
    providers: [],
    imports: [CommonModule, PrimengModule],
})
export class AuthModule {}
